// GENERATED — do not edit. Imports iconNode/paint/viewBox from the sibling .data.ts.

import { createIcon } from "../../../internal/createIcon";
import { iconNode, paint, viewBox } from "./AIcon.data";

export const AIcon = createIcon("AIcon", iconNode, { paint, viewBox });
